import React, { useState, useContext, useEffect, useRef } from "react";
import FuncionesContext, {
  getUserFile,
  uploadFileToS3,
} from "../context/FuncionesContext";
import { Editor } from "primereact/editor";
import InputText from "../ABM/componentes/inputs/InputText";
import Guardar from "../ABM/componentes/botonera/Guardar";
import Cancelar from "../ABM/componentes/botonera/Cancelar";
import { TextareaAutosize } from "@mui/material";
import { ReadOnlyTextArea } from "./EditorTextArea";
import Nullifier from "./Nullifier";
import { useRefDataStore } from "../../..";
import { getAtributo } from "../context/FuncionesContext";

import { v4 as uuidv4 } from "uuid";
import Quill from "quill";
const ImageBlot = Quill.import("formats/image");

class CustomImageBlot extends ImageBlot {
  static create(value) {
    const container = document.createElement("span");
    container.classList.add("custom-image-container");
    container.setAttribute("contenteditable", "false");
    container.style.position = "relative";
    container.style.display = "inline-block";

    const img = document.createElement("img");
    img.setAttribute("src", typeof value === "object" ? value.src : value);
    img.style.width = "auto";
    img.style.height = "100px";
    if (typeof value === "object") {
      if (value.dataId) {
        img.setAttribute("data-id", value.dataId);
        img.setAttribute("id", value.dataId);
        img.style = value.style;
        img.setAttribute("height", value.height);
        img.setAttribute("width", value.width);
      }
      if (value.customAttr) {
        img.setAttribute("custom-attr", value.customAttr);
      }
    }

    container.appendChild(img);

    const resizer = document.createElement("div");
    resizer.classList.add("custom-image-resizer");
    resizer.style.width = "10px";
    resizer.style.height = "10px";
    resizer.style.background = "gray";
    resizer.style.position = "absolute";
    resizer.style.bottom = "0";
    resizer.style.right = "0";
    resizer.style.cursor = "nwse-resize";
    resizer.style.zIndex = "10";
    resizer.style.display = "none";

    container.appendChild(resizer);

    const mouseOverHandler = () => (resizer.style.display = "block");
    const mouseLeaveHandler = () => (resizer.style.display = "none");

    img.addEventListener("mouseenter", mouseOverHandler);
    resizer.addEventListener("mouseenter", mouseOverHandler);
    img.addEventListener("mouseleave", mouseLeaveHandler);
    resizer.addEventListener("mouseleave", mouseLeaveHandler);

    let startX, startY, startWidth, startHeight;

    const mouseDownHandler = function (e) {
      e.preventDefault();
      startX = e.clientX;
      startY = e.clientY;
      startWidth = img.offsetWidth;
      startHeight = img.offsetHeight;
      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    };

    const mouseMoveHandler = function (e) {
      e.preventDefault();
      const newWidth = startWidth + (e.clientX - startX);
      const newHeight = startHeight + (e.clientY - startY);
      img.style.width = newWidth + "px";
      img.style.height = newHeight + "px";
      img.setAttribute("width", newWidth);
      img.setAttribute("height", newHeight);
    };

    const mouseUpHandler = function () {
      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);
      document.removeEventListener("mouseenter", mouseOverHandler);
      document.removeEventListener("mouseleave", mouseLeaveHandler);

      const quillInstance = Quill.find(container.closest(".ql-container"));
      if (quillInstance) {
        quillInstance.root.dispatchEvent(
          new Event("resized", { bubbles: true })
        );
      }
    };

    container.__mouseDownHandler = mouseDownHandler;
    resizer.addEventListener("mousedown", mouseDownHandler);
    container.__eventHandlers = {
      mouseOverHandler,
      mouseLeaveHandler,
      mouseDownHandler,
    };
    container.__resizer = resizer;

    return container;
  }

  static value(node) {
    return {
      src: node.getAttribute("src"),
      dataId: node.getAttribute("data-id"),
      id: node.getAttribute("id"),
      style: node.style,
      height: node.getAttribute("height"),
      width: node.getAttribute("width"),
    };
  }

  format(name, value) {
    if (name === "data-id" || name === "id") {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }

  detach() {
    if (this.domNode && this.domNode.__eventHandlers) {
      const { mouseOverHandler, mouseLeaveHandler, mouseDownHandler } =
        this.domNode.__eventHandlers;
      const img = this.domNode.querySelector("img");
      const resizer = this.domNode.querySelector(".custom-image-resizer");

      if (img) {
        img.removeEventListener("mouseenter", mouseOverHandler);
        img.removeEventListener("mouseleave", mouseLeaveHandler);
      }
      if (resizer) {
        resizer.removeEventListener("mouseenter", mouseOverHandler);
        resizer.removeEventListener("mouseleave", mouseLeaveHandler);
        resizer.removeEventListener("mousedown", mouseDownHandler);
      }
    }
    super.detach();
  }
}

CustomImageBlot.blotName = "customImage";
CustomImageBlot.tagName = "img";
Quill.register(CustomImageBlot);

// EL COMPONENTE REQUIERE QUILL 1.3.7 y PRIMEREACT@5

const NoteTaker = (props) => {
  const {
    data,
    cab,
    campokey,
    context,
    id_elemento,
    setValor,
    valor,
    error,
    setError,
  } = props;
  const { superSubmit, validarRegex } = useContext(FuncionesContext);

  const { opciones } = useContext(context);

  const [v, setStore] = useRefDataStore((s) => s[data._key + campokey]);
  const [update_id] = useRefDataStore(
    (s) => s[data._key + cab.update_id_alias]
  );

  const [value, setValue] = useState(v ?? valor ?? "");
  const [lastValue, setLastvalue] = useState(v ?? valor);
  const [isFocused, setIsFocused] = useState(false);
  const [guardado, setGuardado] = useState(true);
  const [updateId, setUpdateId] = useState(
    update_id ?? data[cab.update_id_alias]
  );

  const miComponenteRef = useRef(null);

  const nombre = (() => {
    if (cab.nombre_alias) {
      return data[cab.nombre_alias];
    }
    return cab.nombre;
  })();

  const esInputABM = opciones.tipo.id === 9;
  const notAbmInput = !esInputABM;
  const permiteNull = getAtributo("permite_null", data, cab);
  const esObligatorioABM = esInputABM && permiteNull === "n";
  const tieneErrorABM = esInputABM && Boolean(error?.[cab.id_a]);

  const disabled = data[cab.id_a + "_disabled"]
    ? data[cab.id_a + "_disabled"] === "s"
    : cab.disabled === "s";

  const limpiarError = () => {
    if (!setError) return;

    setError((errores) => ({
      ...errores,
      [cab.id_a]: false,
    }));
  };

  const handleOnBlur = () => {
    if (!esInputABM || !setError) return;

    setError((errores) => ({
      ...errores,
      [cab.id_a]: !validarRegex(value ?? "", cab.validacion_regex, cab),
    }));
  };

  const handleNull = () => {
    if (!esInputABM) return;

    setValor("null");
    setValue("null");
    limpiarError();
  };

  // NUEVO: detectar icono_obligatorio (desde data o cab)
  const icono_obligatorio = getAtributo("icono_obligatorio", data, cab) === "s";

  let classNames = data[cab.id_a + "_className"] ?? cab.className;

  const handleCancelar = () => {
    setValue(v);
    setLastvalue(v);
    setIsFocused(false);
    setGuardado(true);
  };

  class handleGuardar {
    static update = async () => {
      const valor = value;

      if (valor === null || lastValue?.toString() === valor.toString().trim())
        return;

      if (!validarRegex(valor, cab.validacion_regex, cab)) {
        setValue(v);
        return;
      }

      const { id_a } = cab;
      setIsFocused(false);

      superSubmit({
        valor,
        id_a,
        update_id: updateId,
        handleCancelar,
        cab,
        data,
      })
        .then((result) => {
          setLastvalue(() => valor);
          setStore({ [data._key + campokey]: valor });
          if (!updateId) {
            setStore({
              [data._key + cab.update_id_alias]: result.data.registro.id,
            });
            setUpdateId(result.data.registro.id);
          }

          setGuardado(true);
          return result;
        })
        .catch((err) => {
          console.log("Cancelado ", err);
        });
    };

    static abm = async (e) => {
      e.stopPropagation();
      setValor(e.target.value);
      return e;
    };
  }

  (() => {
    if (updateId) {
      classNames = `${classNames} 
        ${data[cab.id_a + "_update_className"] ?? cab.update_className}`;
      return;
    }
    classNames = classNames + " sinUpdateId";
    return;
  })();

  useEffect(() => {
    const handleClick = (event) => {
      if (
        miComponenteRef &&
        miComponenteRef.current &&
        miComponenteRef.current.contains(event.target)
      ) {
        if (opciones.tipo.id === 9) return;
        setIsFocused(true);
      } else {
        setIsFocused(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [opciones.tipo.id]);

  const insertImage = (url, quill) => {
    let range = quill.getSelection();
    if (!range) {
      range = { index: quill.getLength(), length: 0 };
    }

    const imageId = `img${uuidv4()}`;

    quill.insertEmbed(range.index, "customImage", {
      src: url,
      dataId: imageId,
      width: "auto",
      height: "100px",
    });

    quill.setSelection(range.index + 1, 0);
  };
  const clasico = getAtributo("textarea_clasico", data, cab) === "s";
  const mui = getAtributo("textarea_mui", data, cab) === "s";

  async function uploadImage(file) {
    const url = await uploadFileToS3(file, cab.id_a);
    return url;
  }

  async function imageHandler() {
    const quill = this.quill;
    const file = await getUserFile();
    const url = await uploadImage(file);
    if(typeof url !== "string"){
      alert("Hubo un problema al subir la imagen. ", url?.toString())
      return
    }
    insertImage(url, quill);
  }

  class handleChange {
    static abm = (e) => {
      if (clasico) {
        setValor(e.target.value);
        setValue(e.target.value);
        limpiarError();
        return;
      }
      const nuevoValor = e.htmlValue ?? "";
      setValue(nuevoValor);
      setValor(nuevoValor);
      limpiarError();
    };
    static update = (e) => {
      setGuardado(e.htmlValue === lastValue);
      setValue(e.htmlValue);
    };
    static textareaupdate = (e) => {
      if (
        cab.maximo_caracteres &&
        e.target.value.length > Number(cab.maximo_caracteres)
      )
        return;
      setGuardado(e.target.value === lastValue);
      setValue(e.target.value);
    };
  }

  useEffect(() => {
    const editor = document.getElementById(id_elemento);
    if (!editor) return;

    const handleResize = () => {
      const p = editor.querySelector(".ql-editor");
      if (!p) return;

      const newContent = p.innerHTML.toString();
      handleChange.update({ htmlValue: newContent });
    };

    editor.addEventListener("resized", handleResize);
    return () => {
      editor.removeEventListener("resized", handleResize);
    };
  }, [id_elemento]);

  // Si está deshabilitado, se mantiene render de sólo lectura (sin asterisco)
  if (disabled) {
    return <ReadOnlyTextArea {...props} />;
  }

  if (mui) {
    return (
      <InputText
        {...props}
        setValor={setValor}
        valor={valor}
        textarea
        context={context}
        error={error}
        setError={setError}
      />
    );
  }

  return (
    <div
      style={{
        width: "100%",
        flexWrap: "wrap",
        border: guardado ? "none" : "2px solid red",
      }}
      id={id_elemento}
      className={`tarjeta_grid_item_label_item  d-flex flex-column align-items-start ${
        cab.habilita_insertar_imagenes === "s" ? "" : "ql-image-none"
      }`}
      ref={miComponenteRef}
    >
      {nombre ? (
        <div
          className={
            opciones.tipo.id === 9 ? "labelNoteTakerABM" : "labelNoteTaker"
          }
        >
          {nombre}:
          {esObligatorioABM && (
            <span className="icono_obligatorio" style={{ marginLeft: "4px" }}>
              *
            </span>
          )}
        </div>
      ) : (
        <></>
      )}

      {/* Contenedor para editor/textarea + asterisco a la derecha */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          width: "100%",
        }}
      >
        {clasico ? (
          <TextareaAutosize
            id={id_elemento}
            placeholder={cab.placeholder}
            onBlur={esInputABM ? handleOnBlur : undefined}
            onChange={
              opciones.tipo.id === 9
                ? handleChange.abm
                : opciones.tipo.id === 6
                ? handleChange.textareaupdate
                : handleChange.update
            }
            helperText={cab.helper_text}
            label={cab.label}
            value={value}
            multiline={true}
            maxRows={500}
            minRows={2}
            variant="outlined"
            size="small"
            className={cab.className}
            style={{
              textTransform: cab.solo_mayus === "s" ? "uppercase" : "inherit",
              width: "100%",
              boxShadow: tieneErrorABM
                ? "0 0 0 1px #d32f2f"
                : undefined,
              borderRadius: tieneErrorABM ? "4px" : undefined,
            }}
            disabled={
              data[cab.id_a + "_disabled"]
                ? data[cab.id_a + "_disabled"] === "s"
                : cab.disabled === "s"
            }
          />
        ) : (
          <Editor
            disabled={disabled}
            className={
              disabled
                ? classNames + " textArea_disabled"
                : classNames + " inputTextArea"
            }
            id={id_elemento + "_editor"}
            value={value}
            onBlur={esInputABM ? handleOnBlur : undefined}
            style={{
              width: cab.width_input ?? "100%",
              boxShadow: tieneErrorABM
                ? "0 0 0 1px #d32f2f"
                : undefined,
              borderRadius: tieneErrorABM ? "4px" : undefined,
            }}
            onKeyDownCapture={(e) => {
              if (e.key === "Enter") {
                e.stopPropagation();
              }
            }}
            onTextChange={
              opciones.tipo.id === 9 ? handleChange.abm : handleChange.update
            }
            pt={{
              root: {
                style: {
                  width: cab.width_input ?? "100%",
                },
              },
            }}
            readOnly={disabled}
            modules={{
              toolbar: {
                container: [
                  [{ size: ["small", false, "large", "huge"] }],
                  [{ font: [] }],
                  [{ color: [] }, { background: [] }],
                  [{ align: [] }],
                  ["blockquote", "code-block"],
                  ["bold", "italic", "underline", "strike"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link", "image"],
                ],
                handlers: { image: imageHandler },
              },
            }}
          />
        )}

        {/* Asterisco por icono_obligatorio */}
        {icono_obligatorio && <span className="icono_obligatorio">*</span>}

        {esInputABM && permiteNull === "s" && (
          <Nullifier onClick={handleNull} className="columna_input_null" />
        )}
      </div>

      {tieneErrorABM && cab.helper_text ? (
        <span
          style={{
            color: "#d32f2f",
            fontSize: "0.75rem",
            margin: "0.3rem",
          }}
        >
          {cab.helper_text}
        </span>
      ) : null}

      {notAbmInput && isFocused ? (
        <div
          style={{ width: "100%", margin: "0.2rem" }}
          className="btns-noteTaker"
        >
          <Guardar
            handleSubmit={
              opciones.tipo.id === 9 ? handleGuardar.abm : handleGuardar.update
            }
            texto_confirmar="Guardar"
            size="small"
            buttonId={id_elemento + "_submit"}
            submitOnEnter={false}
          />
          <Cancelar size="small" handleCancelar={handleCancelar} />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default NoteTaker;

export const ABMNoteTaker = (props) => {
  return <div></div>;
};
